import React from 'react'
import {FormattedNumber, FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {ICar} from '../../../../models/Car'
import NoImage from '../../../assets/imgs/no-image.png'
import {BadgeType, ListViewType, Locale, PHOTO_RATIO} from '../../../config/constants'
import {getCarUrl, localizeCar} from '../../../helpers/car'
import LocaleText from '../../common/LocaleText'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import TopStarThumbnail from '../../common/TopStarThumbnail'
import {useLocale} from '../../hocs/hooks'
import {localizeCarLocation} from '../../../helpers/carLocation'
import styles from './CarItem.scss'
import { getGlobalEnv } from '../../../helpers/coreUtil'
import TypeLabel from '../../common/TypeLabel'

const thumbnailWidth = 320 //px
const CarItem = ({car, multiTitle = false, isCatchphrase = false}: {
  car: ICar
  multiTitle?: boolean
  isCatchphrase?: boolean
}) => {
  const locale = useLocale()
  const {
    photos: [{url = NoImage, caption = 'Car Photo'} = {}],
    name,
    catchphrase,
    catchphraseEn,
    price,
    stars,
    totalReviews,
    locations
  } = localizeCar(locale, car)
  const location = locations?.length ? localizeCarLocation(locale, locations[0]) : undefined
  const address = location?.basicAddress

  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSet = getResponsiveSrcSetsFromWH(url, 200, undefined, { webp: true, cdn })
  const isSuperHolder = !!car.holder?.isSuperHolder
  return <div className={[styles.container, 'flex-grow-0 flex-shrink-0 d-flex flex-column position-relative'].filter(Boolean).join(' ')}>
    <div className={['overflow-hidden', styles.image].filter(Boolean).join(' ')}>
      {isSuperHolder && <TypeLabel type={BadgeType.superholder}/>}
      <Link to={getCarUrl(locale, car, false, false, false)}
            className={[styles.imgWrapper, 'd-flex align-items-center justify-content-center'].join(' ')}>
        <ResponsiveImg caption={caption}
                        url={url}
                        noLazy={false}
                        srcSet={srcSet}
                        width={thumbnailWidth}
                        height={thumbnailWidth / PHOTO_RATIO}
                        className={styles.photo}/>
      </Link>
    </div>
    <div className={['text-left d-flex flex-column', styles.info].join(' ')}>
      <Link to={getCarUrl(locale, car, false, false, false)}
            className={
              ['d-block font-weight-bold text-dark text-carstay-black', !multiTitle && 'ellipsis', styles.name]
                .filter(Boolean).join(' ')
            }>
        {isCatchphrase ? (locale === Locale.en ? catchphraseEn : catchphrase) || name : name}
      </Link>
      {!multiTitle && <div className={['font-weight-bold text-carstay-black', styles.infoText].join(' ')}>
        <div className="d-inline-block mr-1 mb-0 font-weight-bold font-size-15">
          ¥<FormattedNumber value={price || 0}/>〜
        </div>
        <span className="font-size-12">/24<LocaleText ja="時間" en=" hours"/></span>
      </div>}
      <div className="d-flex justify-content-between align-items-center mt-auto">
        <div className={['small ellipsis font-weight-bold', styles.address].join(' ')}>
          <span>{address || <FormattedMessage id="car.addressNotFound"/>}</span>
        </div>
        <TopStarThumbnail stars={stars} total={totalReviews} className={['d-flex', styles.stars].join(' ')}/>
      </div>
    </div>
  </div>
}
CarItem.displayName = 'CarItem'
export default CarItem
